import "../css/switch.css";

function Switch({ checked, onChange }) {

    return (

        <label className="switch">

            <input
                type="checkbox"
                checked={checked}
                onChange={(e)=>onChange(e.target.checked)}
            />

            <span className="slider"/>

        </label>

    );

}

export default Switch;